export default "__VITE_ASSET__B36QqNh6__"